export class ProfileGrids {
    constructor () {}

    init() {
        let _this = this;
        _this.bindEvents();
    }

    bindEvents() {
        let _this = this;

        $('.show_hide_advanced_search').click(function () {
            var $aHref = $(this);
            var $container = $aHref.parents('.container').first();
            var $filterContainer = $container.find('.filter-container');
            if ($filterContainer.is(':visible')) {
                $filterContainer.hide();
                $aHref.html($aHref.attr('data-showlabel'));
            } else {
                $filterContainer.show();
                $aHref.html($aHref.attr('data-hidelabel'));
            }

            /** invoke global search key up to init search */
            $container.find('#global_search').keyup();
        });
    }
}